import { render, staticRenderFns } from "./navigationbar.vue?vue&type=template&id=bb5bcdec&scoped=true&"
import script from "./navigationbar.vue?vue&type=script&lang=js&"
export * from "./navigationbar.vue?vue&type=script&lang=js&"
import style0 from "./navigationbar.vue?vue&type=style&index=0&id=bb5bcdec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5bcdec",
  null
  
)

export default component.exports